import { useDispatch } from '@redux';
import { cancelOrdersExchange } from '@redux/ordersExchange/actions';
import { Button, Col, Form, Input, Row, Select } from 'antd';
import ModalCustom from 'components/commons/ModalCustom';
import { EXCHANGE_CANCEL_REASONS_LIST } from 'constants/ordersExchange';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DynamicObjectType } from 'types/commons';
import { formatDateTime } from 'utils/formattedString';

const CancelOrderModal = ({ data }, ref) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const [form] = Form.useForm();

  useImperativeHandle(
    ref,
    () => ({
      openModal: () => setIsOpen(true),
    }),
    [],
  );

  const handleCancel = () => {
    setIsOpen(false);
  };

  const handleCancelOrder = () => {
    form.validateFields().then((values) => {
      setLoading(true);
      dispatch(
        cancelOrdersExchange({
          data: {
            id: data?.id,
            data: { ...values },
          },
          options: {
            isShowSuccessNoti: true,
          },
        }),
      ).then((res) => {
        if (res?.payload?.success) {
          setLoading(false);
          setIsOpen(false);
          window.location.reload();
        }
        setLoading(false);
      });
    });
  };

  return (
    <ModalCustom
      open={isOpen}
      onCancel={handleCancel}
      title={t('ordersExchange.cancelOrder')}
      width={650}
      footer={null}
    >
      <Form form={form} layout="vertical" onFinish={handleCancelOrder}>
        <div className="flex flex-center-between mb-[20px]">
          <div className="title-gray-color">{t('ordersExchange.orderNo')}</div>
          <div className="title-gray-color fw-600">{data?.exchangeNumber}</div>
        </div>
        <div className="flex flex-center-between mb-[20px]">
          <div className="title-gray-color">
            {t('ordersExchange.orderCreatedTime')}
          </div>
          <div className="title-gray-color fw-600">
            {formatDateTime(data?.createdAt)}
          </div>
        </div>
        <Row>
          <Col span={24}>
            <Form.Item
              name="cancelReason"
              label="Reason"
              rules={[{ required: true, message: 'Reason is required' }]}
            >
              <Select
                options={EXCHANGE_CANCEL_REASONS_LIST?.map(
                  (item: DynamicObjectType) => ({
                    value: item?.value,
                    label: t(item?.text),
                  }),
                )}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="cancelNote" label="Note">
              <Input.TextArea />
            </Form.Item>
          </Col>
        </Row>
        <div className="d-flex flex-end">
          <Button
            loading={loading}
            type="primary"
            htmlType="submit"
            className="ml-[5px]"
          >
            {t('button.ok')}
          </Button>
        </div>
      </Form>
    </ModalCustom>
  );
};

export default forwardRef(CancelOrderModal);
